import React, { Component } from 'react';

import PropTypes from 'prop-types';

import onClickOutside from '@adsk/react-onclickoutside';

interface ClickOutside {
  handleClickOutside(): void;
}

export default <T extends ClickOutside = ClickOutside>(
  InnerComponent: React.ComponentType<T>
) => {
  /**
   * HOC That handles a component that needs to handle the clickoutside not from within the component
   * for example, look at UserMenu and ModulePicker.
   */
  class ClickOutsideComponent extends Component<ClickOutside> {
    public static propTypes = {};

    /**
     *
     * @param props
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props: any) {
      super(props);
    }

    /**
     * react-clickoutside uses this as a callback (so it is indeed in use and you can ignore the WebStorm marking)
     */
    handleClickOutside() {
      // This is added to the propTypes of the component when wrapped with onClickOutside as this handler is called by it.
      this.props.handleClickOutside();
    }

    /**
     *
     * @returns {XML}
     */
    render() {
      const { handleClickOutside, ...props } = this.props;
      return <InnerComponent {...(props as T)} />;
    }
  }

  ClickOutsideComponent.propTypes = {
    ...InnerComponent.propTypes,
    /**
     * A handler that will be called when the user menu needs to be closed when clicked outside.
     */
    handleClickOutside: PropTypes.func.isRequired,
  };

  return onClickOutside(ClickOutsideComponent);
};
